import React from 'react';
import { ViewPane, IView } from '@framework-controls/core';
import { JSXIf } from '@framework-controls/jsxconditions';
import css from './DesktopPane.module.scss';
import { ApptVeh, NewVehicle } from 'src/models';
import RenderComponent from 'src/components/RenderComponent/RenderComponent';
import PropertyDisplay from './PropertyDisplay/PropertyDisplay';
import VinInput from '../VinInput/containers/VinInput';
import { VINEntryFlag } from 'src/enums';
import UpdateMileage from 'src/components/AddVehicle/UpdateMileage/containers/UpdateMileage';

interface IProps {
    optionsSelected: NewVehicle;
    leftPaneViewOrder: IView[];
    showVin: VINEntryFlag;
    selectedVehicle?: ApptVeh;
    updateVehicleMileage: (mileage: number) => void,
    prevMileage: string,
    theme: string,
    defaultLen: number,
    Itype: string | undefined;
    TMNAMileage: number,
    colorSensitiveEnabled: boolean,
}

const DesktopPane = (props: IProps) => {
    const { optionsSelected } = props;
    const selectedVehicle = props.selectedVehicle!;
    const leftViewPanes = props.leftPaneViewOrder.map((view): IView => ({ ...view }));

    if (props.showVin === VINEntryFlag.Require && !optionsSelected.vinValid) {
        return (
            <div className={css.desktopPane} id='desktopPane'>
                <VinInput desktopView/>
            </div>
        );
    }

    return (
        <div className={css.desktopPane} id='desktopPane'>
            {!selectedVehicle?.make || (optionsSelected?.make && props.showVin === VINEntryFlag.Require) ||
            (optionsSelected?.make && !optionsSelected?.vin) || optionsSelected?.color !== 'default' ?
                <div className={css.viewPane}>
                    <ViewPane
                        renderer={RenderComponent}
                        views={leftViewPanes}
                    />
                </div> :
                <div className='updateMileage'>
                    <UpdateMileage />
                </div>
            }
            <div className={css.vinSelectedProperties}>
                <JSXIf Condition={props.showVin === VINEntryFlag.Show && !selectedVehicle?.vin && !selectedVehicle?.make}>
                    <VinInput desktopView/>
                </JSXIf>
                <PropertyDisplay
                    optionsSelected={optionsSelected}
                    selectedVehicle={selectedVehicle!}
                    prevMileage={props.prevMileage}
                    theme={props.theme}
                    Itype={props?.Itype}
                    TMNAMileage={props.TMNAMileage}
                    colorSensitiveEnabled={props.colorSensitiveEnabled}
                />
            </div>
        </div>
    );
};

export default DesktopPane;
